/* eslint-disable indent */
import { sendAnalyticEvent } from '@src/components/web-analytic';
import { analyticEvents } from '@src/constants';
import { FormInsuranceAdditionalRisks } from '@src/pages/ifl-flat-form/form-insurance-additional-risks';
import { FormInsuranceAddress } from '@src/pages/ifl-flat-form/form-insurance-address';
import { FormInsurancePeriod } from '@src/pages/ifl-flat-form/form-insurance-period';
import { FormInsuranceRisks } from '@src/pages/ifl-flat-form/form-insurance-risks';
import { FormInsuranceSum } from '@src/pages/ifl-flat-form/form-insurance-sum';
import {
  ComponentsConfig,
  ComponentsConfigType,
  HandleAnalytic,
} from '@src/types';

const handleAnalytic: HandleAnalytic = (currentStep: number) => {
  switch (currentStep) {
    case 1:
      sendAnalyticEvent(analyticEvents.iflFlatPresetRisk);
      break;
    case 2:
      sendAnalyticEvent(analyticEvents.iflFlatPresetAddRisk);
      break;
    case 3:
      sendAnalyticEvent(analyticEvents.iflFlatPresetToCoverage);
      break;
    default:
      break;
  }
};

export const flatComponentsConfig: ComponentsConfig = {
  [ComponentsConfigType.MAIN]: {
    components: [FormInsuranceAddress, FormInsurancePeriod],
  },
  [ComponentsConfigType.SETTINGS]: {
    components: [
      FormInsuranceRisks,
      FormInsuranceAdditionalRisks,
      FormInsuranceSum,
    ],
  },
  [ComponentsConfigType.DEFAULT]: {
    components: [
      FormInsuranceAddress,
      FormInsuranceRisks,
      FormInsuranceAdditionalRisks,
      FormInsuranceSum,
      FormInsurancePeriod,
    ],
  },
  analyticEvent: analyticEvents.iflFlatPresetConfigExit,
  handleAnalytic,
};
